import type { RgbColor } from "utils/hslToRgb";

// A wall's width apart is still next door.
export const ROOM_TOUCH_DISTANCE_M = 0.3;

export const FALLBACK_ROOM_COLOR: RgbColor = [100, 116, 139];
